import React from "react";

const MainPage = () => {
  // Dados do perfil
  const profile = {
    name: "Cleslley de Moura",
    role: "Fullstack Developer",
    subRole: "Computer Science student @ UDF, DF | Developer at LEVEL33",
    avatar: "https://github.com/cleslleydemoura.png",
  };

  // Links Sociais - ADICIONEI A PROPRIEDADE 'hoverColor'
  const socialLinks = [
    { 
      name: "GITHUB", 
      url: "https://github.com/cleslleydemoura", 
      color: "bg-[#b0b0b0]", // Cor normal (cinza claro)
      hoverColor: "hover:bg-[#363636] hover:text-white" // Cor hover (Preto do Github)
    },
    { 
      name: "LINKEDIN", 
      url: "https://www.linkedin.com/in/cleslley/", 
      color: "bg-[#b0b0b0]", // Cor normal (azul claro)
      hoverColor: "hover:bg-[#a3cbf7] hover:text-white" // Cor hover (Azul do LinkedIn)
    },
    { 
      name: "EMAIL", 
      url: "mailto:cleslleydemoura@gmail.com", 
      color: "bg-[#b0b0b0]", // Cor normal (vermelho claro)
      hoverColor: "hover:bg-[#ffb3b3] hover:text-white" // Cor hover (Vermelho Gmail)
    },
    { 
      name: "INSTAGRAM", 
      url: "https://www.instagram.com/cleslleydemoura/", 
      color: "bg-[#b0b0b0]", // Cor normal
      hoverColor: "hover:bg-[#E4405F] hover:text-white" // Rosa oficial do Instagram
    }
  ];

  // Links de Projetos - ADICIONEI CORES MAIS VIVAS NO HOVER
  const projectLinks = [
    { 
      name: "TypeScript Projects", 
      url: "https://github.com/cleslleydemoura?tab=repositories&q=&type=&language=typescript", 
      color: "bg-[#688891] text-white", 
      hoverColor: "hover:bg-[#3178c6]" // Azul TypeScript
    },
    { 
      name: "C# / .NET Projects", 
      url: "https://github.com/cleslleydemoura?tab=repositories&q=&type=&language=c%23", 
      color: "bg-[#5e785c] text-white", 
      hoverColor: "hover:bg-[#17331A]" // Roxo C#
    },
    { 
      name: "JavaScript Projects", 
      url: "https://github.com/cleslleydemoura?tab=repositories&q=&type=&language=javascript", 
      color: "bg-[#998f6d] text-white", 
      hoverColor: "hover:bg-[#f7df1e] hover:text-black" // Amarelo JS
    },
  ];

  return (
    <div className="min-h-screen w-full flex items-center justify-center p-4 relative overflow-hidden bg-gradient-to-b from-[#000000] to-[#3f4d57]">
      
      {/* --- CAMADA DE FUNDO GRANULADO (Noise) --- */}
      <div className="absolute inset-0 z-0 pointer-events-none opacity-30 mix-blend-overlay">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/asfalt-dark.png')] animate-grain"></div>
      </div>

      {/* --- CONTEÚDO PRINCIPAL --- */}
      <div className="relative z-10 w-full max-w-md flex flex-col items-center gap-6">
        
        {/* Cabeçalho do Perfil */}
        <div className="text-center flex flex-col items-center">
          <div className="w-28 h-28 mb-4 rounded-full border-4 border-black shadow-[4px_4px_0px_0px_rgba(255,255,255,0.2)] overflow-hidden bg-white hover:scale-105 transition-transform duration-300">
            <img 
              src={profile.avatar} 
              alt="Avatar" 
              className="w-full h-full object-cover"
            />
          </div>
          <h1 className="text-3xl font-black text-white tracking-tight mb-2 drop-shadow-md">
            @{profile.name.replace(/ /g, "").toLowerCase()}
          </h1>
          <p className="text-sm font-bold text-gray-900 uppercase tracking-widest bg-[#a1ffce] px-3 py-1 rounded-md mb-2 shadow-[2px_2px_0px_0px_rgba(0,0,0,1)]">
            {profile.role}
          </p>
          <span className="text-xs font-medium text-gray-300 max-w-xs leading-relaxed">
            {profile.subRole}
          </span>
        </div>

        {/* Seção: Links Sociais */}
        <div className="w-full flex flex-col gap-4 mt-2">
          {socialLinks.map((link, index) => (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`
                relative w-full py-4 text-center font-black uppercase tracking-wider text-black
                border-2 border-black rounded-full shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]
                transition-all duration-200 
                hover:-translate-y-1 hover:shadow-[6px_6px_0px_0px_rgba(255,255,255,0.5)]
                active:translate-y-0.5 active:shadow-[2px_2px_0px_0px_rgba(0,0,0,1)]
                ${link.color} ${link.hoverColor}
              `}
            >
              {link.name}
            </a>
          ))}
        </div>

        {/* Separador */}
        <div className="w-full flex items-center gap-2 mt-4 opacity-70">
            <div className="h-0.5 bg-gray-500 flex-grow rounded-full"></div>
            <span className="text-xs font-bold uppercase text-gray-400">Projects</span>
            <div className="h-0.5 bg-gray-500 flex-grow rounded-full"></div>
        </div>

        {/* Seção: Projetos */}
        <div className="w-full flex flex-col gap-3 pb-8">
          {projectLinks.map((link, index) => (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`
                flex items-center justify-center w-full py-3 font-bold
                rounded-lg border-2 border-black shadow-[3px_3px_0px_0px_rgba(0,0,0,1)]
                transition-all duration-200 
                hover:-translate-y-1 hover:shadow-[5px_5px_0px_0px_rgba(255,255,255,0.3)]
                ${link.color} ${link.hoverColor}
              `}
            >
              {link.name}
            </a>
          ))}
        </div>

      </div>
    </div>
  );
};

export default MainPage;
